/**
 * 站点配置
 */

import { request } from "../request";
import type {
  PopupConfigItem,
  TopbarImageItem,
} from "@xmiles/holopix-types";


/**
 * 获取站点 topbar 图片
 * 登录后需带上 userId（如 ?userId=123），后端按用户会员类型返回对应 userScope 的 banner
 */
export const getTopbarImageList = (userId?: string | number) => {
  return request<TopbarImageItem[]>({
    url: "/pino_service_api/bannerConfig/list",
    method: "get",
    params: userId != null && userId !== "" ? { userId } : undefined,
    data: {
      data: {},
    },
  });
};


/**
 * 获取站点弹窗配置
 * 登录后需带上 userId（如 ?userId=123），后端按用户会员类型返回对应 userScope 的弹窗
 */
export const getPopupConfigList = (userId?: string | number) => {
  return request<PopupConfigItem[]>({
    url: "/pino_service_api/popupConfig/list",
    method: "get",
    params: userId != null && userId !== "" ? { userId } : undefined,
    data: {
      data: {},
    },
  });
};


/** canvasPopupConfig/list 返回的配置项 */
export interface CanvasPopupConfigResp {
  id: number;
  title: string;
  picture: string;
  link: string;
  /** JSON 字符串，解析后为 CanvasPopupParam */
  param: string;
  /** 展示规则：0=仅展示一次，1=每日展示一次 */
  displayRules: number;
  /** 曝光用户范围（前端不过滤，后端按 userId 过滤） */
  userScope: number;
  /** 状态：0=待开始，1=进行中，2=已完成 */
  status: number;
  /** 排序权重（升序，越小越优先） */
  sort: number;
  startDate: string;
  endDate: string;
  ctime: string;
  utime: string;
  /** 删除状态：0=未删除，1=已删除 */
  deleteStatus: number;
}

/** param.viewDetail：查看详情按钮配置（可选） */
export interface CanvasPopupViewDetail {
  /** 按钮文案 */
  buttonName: string;
  /** 按钮跳转链接 */
  link: string;
}

/** param 字段解析后的结构 */
export interface CanvasPopupParam {
  /** 前台路由 name 数组，决定弹窗在哪些路由展示 */
  routeName: string[];
  /** 轮播图 URL 数组，按顺序轮播 */
  pictures: string[];
  /** 查看详情按钮配置，不填则不显示该按钮 */
  viewDetail?: CanvasPopupViewDetail;
}

/**
 * 获取升级弹窗配置列表
 * 登录后需带上 userId（如 ?userId=123），后端按用户会员类型返回对应 userScope 的弹窗
 */
export const getCanvasPopupConfigList = (userId?: string | number) => {
  return request<CanvasPopupConfigResp[]>({
    url: "/pino_service_api/canvasPopupConfig/list",
    method: "get",
    params: userId != null && userId !== "" ? { userId } : undefined,
    data: {
      data: {},
    },
  });
};
